import axios from "axios";
import { Base_URL } from "../url";

// Create milestone
export const createMilestone = async (milestoneData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/MilestoneMaster/CreateMilestone?UserName=${userName}`,
      milestoneData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create milestone"
    );
  }
};

// Get all milestones
export const getAllMilestones = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/MilestoneMaster/GetAllMilestones`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch milestones"
    );
  }
};

// Get milestone by ID
export const getMilestoneById = async (milestoneMavroId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/MilestoneMaster/GetMilestoneById/${milestoneMavroId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch milestone"
    );
  }
};

// Get milestones by project ID
export const getMilestonesByProzmaPrId = async (prozmaPrId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/MilestoneMaster/GetMilestonesByProzmaPrId/${prozmaPrId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch milestones for project"
    );
  }
};

// Get milestones by organization ID
export const getMilestonesByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/MilestoneMaster/GetMilestonesByOrgId/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch milestones for organization"
    );
  }
};

// Get milestones by both project and organization ID
export const getMilestonesByProjectAndOrg = async (prozmaPrId, orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/MilestoneMaster/GetMilestonesByProjectAndOrg`,
      {
        params: {
          prozmaPrId,
          orgId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch milestones for project and organization"
    );
  }
};

// Update milestone
export const updateMilestone = async (milestoneData, userName) => {
  try {
    const response = await axios.put(
      `${Base_URL}/MilestoneMaster/UpdateMilestone?UserName=${userName}`,
      milestoneData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update milestone"
    );
  }
};

// Download milestones Excel
export const downloadMilestonesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/MilestoneMaster/DownloadMilestonesExcel`,
      {},
      {
        responseType: "blob", // Important for file download
      }
    );
    return response;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to download milestones Excel"
    );
  }
};

// Search milestones with multiple parameters
export const searchMilestones = async (searchParams = {}) => {
  try {
    const response = await axios.get(
      `${Base_URL}/MilestoneMaster/SearchMilestones`,
      {
        params: searchParams,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to search milestones"
    );
  }
};
